<template>
  <l-icon v-bind="markerOptions" />
</template>

<script>
import { LIcon } from 'vue2-leaflet'

export default {
  name: 'MapIcon',
  props: {
    pin: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    },
    styleColors: {
      type: Array,
      default: () => []
    },
    mediaRepresentation: {
      type: Boolean,
      default: false
    },
    isBookmark: {
      type: Boolean,
      required: true
    },
    bookmarkColor: {
      type: String,
      required: true
    },
    bookmarkOutlineColor: {
      type: String,
      required: true
    }
  },
  components: {
    LIcon
  },
  computed: {
    mapObject () {
      return this.$parent.mapObject
    },
    markerOptions () {
      return {
          iconUrl: this.markerIcon,
          className: 'map-marker',
          iconSize: [48, 48],
          iconAnchor: [12, 48],
          popupAnchor: [0, -40]
      }
    },
    markerColors () {
      let color1, color2
      if (this.isBookmark) {
        color1 = this.bookmarkColor
        color2 = this.bookmarkOutlineColor
      } else if (this.category.iconType === 1 && this.category.primaryColor && this.category.secondaryColor) {
        color1 = this.category.primaryColor
        color2 = this.category.secondaryColor
      } else {
        color1 = this.styleColors[0]
        color2 = this.styleColors[1]
      }

      return [color1, color2]
    },
    markerIcon () {
      // default circle icon
      let innerIcon = `
            <circle cx="0" cy="4" r="4" fill="${this.markerColors[1]}" stroke="none"/>
          `
      // If icon is a custom image
      if (this.category.iconType === 2 && this.category.icon) {
        return this.category.icon.path
      } else {
        // Is media representation enabled
        if (this.mediaRepresentation) {
          // 360 icon
          if (this.pin.panoramas.length >=1) {
            innerIcon = `
              <g xmlns="http://www.w3.org/2000/svg" transform="translate(-17,-193)">
                <path xmlns="http://www.w3.org/2000/svg" style="fill:${this.markerColors[1]};stroke-width:0.0470823" d="m 9.793153,199.9411 c -0.3707771,-0.0718 -0.8638745,-0.34912 -1.1206499,-0.63007 -0.2508853,-0.27451 -0.3687307,-0.54414 -0.4168834,-0.95384 l -0.029146,-0.248 H 8.744976 c 0.7201798,0 0.7959697,0.0195 0.8273502,0.21287 0.07585,0.46742 0.6703558,0.77979 1.2083348,0.63494 0.405618,-0.10928 0.659846,-0.49029 0.659846,-0.98906 0,-0.67472 -0.319196,-0.92779 -1.230847,-0.9759 l -0.5106711,-0.0268 v -0.48731 -0.48731 h 0.4151951 c 0.475498,0 0.839699,-0.0912 0.986019,-0.24696 0.247528,-0.26349 0.316858,-0.74744 0.157381,-1.09859 -0.328535,-0.72335 -1.4806283,-0.58346 -1.627154,0.19759 L 9.600557,195.0019 H 8.9698583 c -0.3468839,0 -0.641469,-0.0175 -0.6546329,-0.0387 -0.013162,-0.0212 0.00672,-0.18524 0.044186,-0.3643 0.1134699,-0.54233 0.4521568,-0.93827 1.0564654,-1.23507 0.2517687,-0.12364 0.2836266,-0.12742 1.0599692,-0.12588 0.907753,10e-4 1.110717,0.0525 1.553715,0.38798 0.49038,0.37146 0.766683,1.25278 0.571942,1.82432 -0.09494,0.27866 -0.397401,0.67661 -0.644255,0.84769 -0.102652,0.0713 -0.1866,0.14235 -0.186549,0.15825 4.7e-5,0.016 0.108891,0.10309 0.241889,0.19368 0.256146,0.17459 0.489581,0.43437 0.634579,0.70625 0.123608,0.23178 0.121706,1.04469 -0.0034,1.41246 -0.105428,0.31015 -0.524146,0.75155 -0.906654,0.95577 -0.434301,0.23185 -1.34371,0.33335 -1.9440426,0.21699 z m 5.426997,-0.0469 c -0.577898,-0.1831 -1.134383,-0.7447 -1.374895,-1.38753 -0.161906,-0.43273 -0.204305,-0.92708 -0.178975,-2.0868 0.03275,-1.49958 0.147737,-1.86705 0.784261,-2.50627 0.600727,-0.60331 0.963222,-0.72637 2.033911,-0.69053 0.697165,0.0233 1.077275,0.11172 1.077275,0.25063 0,0.0749 -0.177122,0.82632 -0.200185,0.84937 -0.0089,0.008 -0.216385,-0.0252 -0.461176,-0.0757 -0.244789,-0.0505 -0.499491,-0.0921 -0.566004,-0.0925 -0.259257,-10e-4 -0.601269,0.14298 -0.833286,0.35157 -0.288023,0.25897 -0.439721,0.58944 -0.471517,1.02721 l -0.02324,0.32005 0.361841,-0.19056 c 0.360834,-0.19005 0.363318,-0.19059 0.892664,-0.19059 0.696134,0 0.908087,0.071 1.260123,0.42279 0.450119,0.44965 0.66322,1.0224 0.666041,1.79008 0.0033,0.86893 -0.4301,1.68107 -1.087874,2.03907 -0.497342,0.27071 -1.324426,0.34538 -1.878955,0.16969 z m 1.037292,-0.95405 c 0.407825,-0.17041 0.621385,-0.66647 0.588694,-1.36745 -0.02065,-0.44313 -0.08884,-0.64708 -0.290415,-0.86869 -0.325019,-0.35731 -0.947411,-0.34643 -1.434498,0.0251 l -0.162084,0.12365 0.02512,0.56938 c 0.02695,0.61073 0.08994,0.84169 0.323876,1.18746 0.14265,0.21085 0.452309,0.3941 0.666072,0.39416 0.07204,2e-5 0.199496,-0.0286 0.283228,-0.0637 z m 4.267141,0.98795 c -0.317379,-0.0856 -0.599244,-0.26787 -0.897115,-0.58021 -0.567166,-0.59475 -0.627643,-0.86264 -0.625059,-2.76888 0.0019,-1.35095 0.0097,-1.48727 0.104646,-1.83215 0.05647,-0.20494 0.166799,-0.47257 0.245192,-0.59473 0.196345,-0.30599 0.613817,-0.68995 0.876509,-0.80614 0.259863,-0.11499 0.816668,-0.17099 1.303346,-0.1312 0.815975,0.0667 1.446213,0.63069 1.733955,1.55153 0.105917,0.33899 0.110337,0.4125 0.110337,1.83623 0,1.3059 -0.01038,1.51684 -0.08657,1.76557 -0.18516,0.60422 -0.551919,1.10745 -0.997365,1.3685 -0.390046,0.22858 -1.274828,0.32441 -1.767868,0.19147 z m 1.122848,-1.09592 c 0.30212,-0.23045 0.408972,-0.63435 0.45905,-1.73525 0.03521,-0.77381 -0.03809,-1.917 -0.146234,-2.28118 -0.141331,-0.47592 -0.558729,-0.74036 -0.973285,-0.61666 -0.246268,0.0735 -0.530369,0.35968 -0.59769,0.60208 -0.06797,0.24472 -0.06574,3.3183 0.0026,3.56696 0.05802,0.21122 0.392759,0.567 0.568575,0.60432 0.219969,0.0468 0.522975,-0.0152 0.687012,-0.14027 z m 3.564659,-3.2337 c -0.257118,-0.1003 -0.447209,-0.23916 -0.570256,-0.41672 -0.450518,-0.65011 -0.276138,-1.46715 0.39767,-1.86325 0.289175,-0.16999 0.775843,-0.18187 1.067655,-0.0261 0.244535,0.1305 0.517775,0.41585 0.60977,0.63669 0.102209,0.24533 0.09364,0.76457 -0.01654,1.002 -0.255548,0.55075 -0.968017,0.87021 -1.488307,0.66735 z m 0.661035,-0.71824 c 0.349345,-0.16577 0.334724,-0.75186 -0.02337,-0.93703 -0.186641,-0.0966 -0.371401,-0.0896 -0.552365,0.0208 -0.324602,0.19792 -0.289335,0.80639 0.05484,0.9459 0.152894,0.0619 0.351701,0.0506 0.520916,-0.0296 z"/>
              </g>
            `
          }
          // play icon
          if (this.pin.videos.length >=1) {
            innerIcon = `
              <g xmlns="http://www.w3.org/2000/svg" transform="translate(131,0)">
                <path xmlns="http://www.w3.org/2000/svg" style="fill:${this.markerColors[1]};stroke-width:0.0117882" d="m -133.55304,9.9131986 c -0.12866,-0.02773 -0.24165,-0.091361 -0.34226,-0.1927255 -0.10207,-0.102839 -0.15459,-0.1937858 -0.18851,-0.3263767 -0.023,-0.090073 -0.0233,-0.1538972 -0.0233,-5.9459936 0,-5.7920969 2.5e-4,-5.8559201 0.0233,-5.9459934 0.0339,-0.1325907 0.0865,-0.2235382 0.18851,-0.326376 0.17309,-0.1744071 0.40335,-0.2439714 0.64091,-0.1936365 0.0443,0.0094 0.10796,0.029753 0.14145,0.045248 0.0335,0.015495 2.03186,1.3411509 4.44081,2.94589291 4.81299,3.20620389 4.45784,2.96025699 4.54965,3.15068829 0.058,0.1205533 0.0754,0.2114793 0.0679,0.3567643 -0.01,0.1785426 -0.077,0.3288052 -0.20473,0.4543637 -0.07,0.068809 -8.75987,5.8915959 -8.85625,5.9342792 -0.13595,0.060201 -0.28999,0.075648 -0.43745,0.043871 z"/>
              </g>
            `
          }
        }
        const svgIcon = `
            <svg width="64" xmlns="http://www.w3.org/2000/svg" height="64" viewBox="-16 -18 64 64">
                <filter id="blur">
                    <feGaussianBlur in="SourceGraphic" stdDeviation="3" />
                </filter>
                <path fill="rgba(0,0,0,.4)" stroke="none"
                    transform="translate(-2,48) scale(1,0.5) rotate(30) translate(0,-46)"
                    filter="url(#blur)"
                    d="M 0,47
                    Q 0,32 10,15
                    A 15,15 0,1,0 -10,15
                    Q 0,32 0,47" />
                <path fill="${this.markerColors[0]}" stroke="${this.markerColors[1]}" stroke-width="2"
                    d="M 0,47
                    Q 0,32 10,15
                    A 15,15 0,1,0 -10,15
                    Q 0,32 0,47" />
                ${innerIcon}
            </svg>`
        return `data:image/svg+xml;base64,${btoa(svgIcon)}`
      }
    }
  }
}
</script>